module.exports = __webpack_public_path__ + "img/150-Blanc Papyrus.jpg";